import { z } from 'zod'

/**
 * 운영 설정 API 계약 (BIZ-51). 운영자만 조회·변경한다(app_setting 키-값에 저장).
 * 첫 설정은 자동 발주(autoDispatch): 접수 시 단일 업체로 발주까지 자동 진행할지.
 */

/** 자동 발주 대상 선택용 기업 한 줄. */
export const autoDispatchCompany = z.object({
  id: z.number().int(),
  name: z.string(),
  autoDispatch: z.boolean(),
})
export type AutoDispatchCompany = z.infer<typeof autoDispatchCompany>

export const opsSettingsResponse = z.object({
  /** 접수 시 자동 발주 마스터 on/off. */
  autoDispatch: z.boolean(),
  /** 자동 발주 대상 기업 목록(마스터가 켜졌을 때 선택된 기업만 자동 발주). */
  companies: z.array(autoDispatchCompany),
  /** 기본 발주 업체 id — 상품을 공급하는 활성 업체가 여러 곳일 때 이 업체로 자동 발주한다. 미지정이면 null. */
  dispatchVendorId: z.number().int().nullable(),
  /** 전역 기본 할인율·적립율(BIZ-74) — 퍼센트(0~100). 회사 오버라이드가 없으면 이 값을 쓴다. */
  pointDiscountRatePercent: z.number(),
  pointEarnRatePercent: z.number(),
  /** 판매 추천 적립율(BIZ-75) — 퍼센트(0~100). 피추천 회사 주문이 배송완료되면 추천인 회사에 정가×이 율 적립. */
  referralSaleRatePercent: z.number(),
})
export type OpsSettingsResponse = z.infer<typeof opsSettingsResponse>

/** 마스터 토글 / 기본 발주 업체를 바꾼다(준 필드만). dispatchVendorId=null이면 지정 해제. */
export const updateOpsSettingsRequest = z
  .object({
    autoDispatch: z.boolean(),
    dispatchVendorId: z.number().int().positive().nullable(),
    pointDiscountRatePercent: z.number().min(0).max(100),
    pointEarnRatePercent: z.number().min(0).max(100),
    referralSaleRatePercent: z.number().min(0).max(100),
  })
  .partial()
export type UpdateOpsSettingsRequest = z.infer<typeof updateOpsSettingsRequest>

/** 기업별 대상 여부를 바꾼다. */
export const updateCompanyAutoDispatchRequest = z.object({
  autoDispatch: z.boolean(),
})
export type UpdateCompanyAutoDispatchRequest = z.infer<typeof updateCompanyAutoDispatchRequest>
